import axios from '../../http'

class XBHome {
  // xb获取侧边栏数据
  getXBMenu() {
    const url = `/api/index/search/left`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb获取底部数据
  getXBbottom() {
    const url = `/api/index/search/bottom`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取商城基础信息
  getXBBasicInformation() {
    const url = `/api/index/setting`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取客服数据
  getXBCusservice() {
    const url = `/api/index/cus/service`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb获取栏目信息
  getXBColumn() {
    const url = `/api/index/search/top`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb根据id获取栏目详细信息
  getXBColumnDetail(id) {
    const url = `/api/index/search/top/get?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb判断当前用户是否可以未登录浏览商品
  getXBGuestSetting() {
    const url = `/api/index/guest/setting`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //根据id获取最新商品信息
  getXBGoodsFew(goodsId) {
    const url = `/api/xb/goods/get/few?goodsId=${goodsId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //活动列表
  getXBActivityList() {
    const url = `/api/xb/goods/activity/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //活动商品列表
  getXBActivityGoodsList(id) {
    const url = `/api/xb/goods/activity/goods?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default XBHome;
